import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

import {CreateNewMeetingButton} from './create-new-meeting-button';

export function EmptyState() {
    return (
        <EmptyStateLarge
            title='Hassle-free meeting management'
            subtitle='Scheduler helps you effortlessly schedule meetings, eliminating the hassle of back-and-forth communication.'
            detailTextBullets={[
                'Set up meetings easily and avoid time-consuming email chains.',
                'Integrate with your calendar to display your availability, making it easy for others to select convenient times.',
                'Customize meeting settings according to your preferences, including duration, buffer time, and more.',
            ]}
            cta={<CreateNewMeetingButton size='xlarge' />}
            icon={<Illustration src='calendar-lady' width={300} />}
        />
    );
}
